import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2
} from '@angular/core';

@Directive({
  selector: '[appTooltipOnEllipsis]',
  standalone: false
})
export class TooltipOnEllipsisDirective {
  private _filter = '';
  get filter(): string {
    return this._filter;
  }
  @Input() set filter(value: string) {
    this._filter = (value ?? '').replace('.', '');
  }

  @Input() tooltipText?: string | null;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  onMouseEnter(): void {
    const element = this.elementRef.nativeElement;
    if (
      element.offsetWidth < element.scrollWidth ||
      element.offsetHeight < element.scrollHeight
    ) {
      element.classList.add(this.filter);
      this.renderer.setAttribute(element, 'data-title', this.tooltipText ?? '');
    } else {
      element.classList.remove(this.filter);
      this.renderer.removeAttribute(element, 'data-title');
    }
  }
}
